import { ErrorComponent } from "@weirgroup/weir-dls";
import { useNavigate } from "react-router-dom";
import { routePath } from "../../constants/navigation.constants";
export default function ErrorPage(){
    const navigate = useNavigate();
    return <div>
        <ErrorComponent 
             errorCode="404"
             errorDescription=""
             errorSubTitle=""
             onHomePageBtnClick={()=>{navigate(routePath.HOMEPAGE)}}
             onTryAgainBtnClick={()=>{window.location.reload()}}
        />
    </div>
}